import React, { useState, useEffect } from 'react';

import Modal from 'components/Tvendo/Common/ModalBase';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import FilterScale from 'components/Tvendo/Common/FilterScale';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

export default function ModalProviderGroupDetail({ model, group, setOpen, showNotify, reload }) {
  const [dataChanging, setDataChanging] = useState({});
  const [getData, setGetData] = useState({});
  const [requireds, setRequireds] = useState([]);

  const handleChange = (e) => {
    setDataChanging({ ...dataChanging, [e.target.name]: e.target.value });
  };

  const handleRow = (value) => {
    setDataChanging({ ...dataChanging, item_id: value });
  };

  const setDataFilter = (data) => {
    if (dataChanging.item_type === 'L') {
      setRequireds(['line']);
      handleRow(data.logi_line_id);
    }
    if (dataChanging.item_type === 'F') {
      setRequireds(['family']);
      handleRow(data.logi_family_id);
    }
    if (dataChanging.item_type === 'P') {
      setRequireds(['product']);
      handleRow(data.logi_product_id);
    }
  };

  useEffect(() => {
    setDataFilter(getData);
  }, [dataChanging.item_type, getData]);

  return (
    <Modal
      title={group.CardName}
      model={model}
      setOpen={setOpen}
      showNotify={showNotify}
      reload={reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity={`com/provider-group/${group.id}/detail`}
    >
      <GridContainer>
        <GridItem xs={12} md={12}>
          <FormControl fullWidth margin="normal" size="small" required>
            <InputLabel>Tipo Artículo</InputLabel>
            <Select
              value={dataChanging.item_type || ''}
              inputProps={{
                name: 'item_type',
                onChange: handleChange
              }}
            >
              <MenuItem value="L">Línea</MenuItem>
              <MenuItem value="F">Familia</MenuItem>
              {/* <MenuItem value="S">Subfamilia</MenuItem> */}
              <MenuItem value="P">Producto</MenuItem>
            </Select>
          </FormControl>
        </GridItem>
        <FilterScale
          fullWidth
          getFilter={setGetData}
          providerID={group.base_business_partner_id}
          category={!!dataChanging.item_type}
          line={dataChanging.item_type === 'L' || dataChanging.item_type === 'P' ? true : false}
          family={dataChanging.item_type === 'F' || dataChanging.item_type === 'P' ? true : false}
          product={dataChanging.item_type === 'P' ? true : false}
          reqFields={requireds}
          type={dataChanging.item_type}
        />
      </GridContainer>
    </Modal>
  );
}
